const inventoryLabResult = {
  path: "/inventory/lab-result/search",
  name: "inventorySelection",
  component: () => import(/* webpackChunkName: "inventorySelectionIndex" */ `@/components/inventorySelection/InventorySelectionIndex.vue`),
  meta: { authorize: ['Administrator', 'Manager', 'Technician'], requiresAuth: true }
};

export default inventoryLabResult;
    